import React, { useState, useEffect } from "react";
import Create_Notice from "../Notice_board/Create_Notice";
import axios from "../../../axios";
// css only of list of holidays part
import "../../styles/index.css";
import DeleteNotice from "./DeleteNotice";
import NewHolidaysList from "../PopUp/listHolidays/NewHolidaysList";
import ListOfTeachersPop from "./ListOfTeachersPop";
import { toast } from "react-toastify";
import { IP } from "../../../internalServer";
import { format } from "date-fns";
import { iconData } from "../../../iconData";
import MideaViewer from "../../../midea_viewer/MideaViewer";
import { hasFeature } from "../../../Utils/features";
import { FaRegEye, FaArrowRight } from "react-icons/fa";

const Add_class_material = ({
  onSucess,
  noticeData,
  setNoticeData,
  teacherListPopup,
  setTeacherListPopup,
  TodayDate,
}) => {
  const [createNotice, setCreateNotice] = useState();
  const [listHolidays, setListHolidays] = useState(false);

  let Teacher_Id = JSON.parse(localStorage.getItem("Teacher_id"));
  const schoolId = JSON.parse(localStorage.getItem("schoolId"));
  const academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicYearSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  const [deleteNotice, setDeleteNotice] = useState();
  const [deletedNoticeId, setDeletedNoticeId] = useState(null);
  const [holidaysArray, setHolidaysArray] = useState([]);
  const [selectedNotice, setSelectedNotice] = useState(null);
  const [zoomedImage, setZoomedImage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [mideaviewer, setMideaviewer] = useState(false);
  // const [isClicked, setIsClicked] = useState(false)
  const [responseAttach, setResponseAttach] = useState();
  useEffect(() => {
    //Remove duplicate code
    handleRefetch();
  }, [Teacher_Id]);

  // const handleRefetch = async () => {
  //   try {
  //     let res1 = {
  //       teacher_id: Teacher_Id,
  //     };
  //     let response = await axios.post(
  //       "/api/v1/noticeBoard/notice/getByTeacher",
  //       res1
  //     );
  //     //Remove code from UI
  //     if (response.data.data.length === 0) {
  //       setData([]);
  //       return false;
  //     }
  //     response.data.data.forEach(function (item) {
  //       if (item.status === "active") {
  //         setData(response.data.data);
  //       }
  //     });
  //   } catch (error) {
  //     console.log("error", error)
  //   }
  // };

  const handleRefetch = async () => {
    try {
      const res = await axios.get(
        `/api/v1/noticeBoard/notice/get?schoolId=${schoolId}&academicSessionId=${academicYearSessionId}&timetableSessionId=${timeTableSessionId}&start=${TodayDate}&end=${TodayDate}`,
      );
      setNoticeData(res.data.data);
    } catch (err) {
      if (err.message === "No Internet Connection") {
        alert("No Internet Connection");
        return;
      }
      console.log(err);
    }
  };

  useEffect(() => {
    const helper1 = async () => {
      try {
        if (!academicYearId) {
          toast.error(
            "There are no allocations set for your login. Please contact the school admin for assistance.",
          );
          return;
        }

        const res = await axios.get(
          `/api/v1/school/holiday/get/academicYear/${academicYearId}`,
        );

        // Agar backend 200 ke sath status:false bhejta hai
        if (!res.data?.status) {
          toast.error(res.data?.message || "Something went wrong");
          setHolidaysArray([]);
          return;
        }

        const holidaysByMonth = res.data.data.reduce((result, holiday) => {
          const holidayObj = {
            startDate: holiday.start_date,
            endDate: holiday.end_date,
            name: holiday.name,
          };

          const month = holiday.start_date.split(" ")[0];

          if (!result[month]) {
            result[month] = {
              Month: month,
              holidays: [],
            };
          }

          result[month].holidays.push(holidayObj);
          return result;
        }, {});

        setHolidaysArray(Object.values(holidaysByMonth));
      } catch (error) {
        console.log(error);

        // Internet
        if (!navigator.onLine) {
          toast.error("No Internet Connection");
          return;
        }

        // Axios error response
        if (error.response) {
          const { status, data } = error.response;

          if (status === 400) {
            setHolidaysArray([]);
            return;
          }

          toast.error(data?.message || "Something went wrong");
          setHolidaysArray([]);
          return;
        }

        toast.error(error.message || "Something went wrong");
        setHolidaysArray([]);
      }
    };

    helper1();
  }, [academicYearId]);
  const allHolidays = holidaysArray.map((item) => item.holidays).flat();

  const attachformat = (para) => {
    if (para !== undefined) {
      const filePath = para;
      const fileArr = filePath.split("/");
      const fileName = fileArr[fileArr.length - 1];
      const extractedFileName = fileName.split("_")[1];
      return extractedFileName;
    }
  };

  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };

  const hasNoticeFeature = hasFeature("NB_MGT");

  const getExtension = (file) => file?.split(".").pop()?.toLowerCase();

  const isImage = (ext) => ["jpg", "jpeg", "png"].includes(ext);

  const isPdf = (ext) => ext === "pdf";
  const isVideo = (ext) => ext === "mp4";

  return (
    <>
      {/* <div className="list_Holidays_container d-flex justify-content-end">
        <p onClick={(e) => setListHolidays(true)} className="list_holiday mr-4">
          List of Holidays
        </p>
      </div> */}
      <div class="container-fluid my-4">
        <div class="row g-4">
          {/* <!-- Upcoming Events --> */}
          {hasNoticeFeature && (
            <div className="col-md-6">
              <div className="border rounded shadow-sm">
                <div
                  className="d-flex justify-content-between align-items-center text-white p-3 rounded-top"
                  style={{ backgroundColor: "#f57c00" }}
                >
                  <h6 className="mb-0 fw-bold">Today Notices</h6>
                </div>

                <div
                  className="p-3 orange-scrollBar"
                  style={{ height: "310px", overflowY: "auto" }}
                >
                  {noticeData && noticeData.length > 0 ? (
                    noticeData.map((item, idx) => {
                      const start = new Date(item.startDate);
                      const end = new Date(item.deadline);
                      const splitText = item?.notice?.substring(0, 160) + "...";

                      return (
                        <div
                          key={item.id || idx}
                          className={`d-flex gap-3 align-items-center rounded p-2 shadow-sm bg-white border  mb-3 ${
                            idx !== noticeData.length - 1
                              ? "border-bottom pb-2"
                              : ""
                          }`}
                          style={{
                            cursor: "pointer",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",

                            display: "-webkit-box",
                            WebkitLineClamp: 10,
                            WebkitBoxOrient: "vertical",

                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                          }}
                          onClick={() => {
                            setSelectedNotice(item);
                            setShowModal(true);
                          }}
                        >
                          <img
                            src="https://img.icons8.com/ios/50/user-group-man-man--v1.png"
                            alt="icon"
                            width="32"
                            height="32"
                          />
                          <div>
                            <p className="mb-1 fw-semibold ">{splitText}</p>
                            <small className="text-muted d-block">
                              <i className="bi bi-calendar-event me-1"></i>{" "}
                              {format(start, "dd MMM yyyy")}
                            </small>
                            <div
                              className="mt-1 d-inline-flex align-items-center gap-2 px-2 rounded-pill"
                              style={{
                                background: "#eef4ff",
                                color: "#0d6efd",
                                fontSize: "12px",
                                fontWeight: 600,
                                width: "fit-content",
                                transition: "0.3s",
                              }}
                            >
                              <FaRegEye />
                              <span>Click for more details</span>
                              <FaArrowRight size={12} />
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p className="text-muted">No upcoming notices available.</p>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* <!-- List of Holidays --> */}
          <div className={` ${hasNoticeFeature ? "col-md-6" : "col-md-12"}`}>
            <div className="border rounded shadow-sm">
              <div
                className="d-flex justify-content-between align-items-center text-white p-3 rounded-top"
                style={{ backgroundColor: "#f57c00" }}
              >
                <h6 className="mb-0 fw-bold">List of Holidays</h6>
              </div>

              <div
                className="p-3 orange-scrollBar"
                style={{ height: "310px", overflowY: "auto" }}
              >
                {allHolidays && allHolidays.length > 0 ? (
                  allHolidays.map((holiday, idx) => {
                    const start = new Date(holiday.startDate);
                    const end = new Date(holiday.endDate);

                    const isSameDay =
                      start.toDateString() === end.toDateString();

                    const formatDateBox = (dateObj) => {
                      const month = format(dateObj, "MMM").toUpperCase();
                      const day = format(dateObj, "dd");
                      const year = format(dateObj, "yyyy");
                      const dayName = format(dateObj, "EEEE");

                      return (
                        <div className="bg-light rounded px-2 py-1 text-center me-1 ms-1">
                          <div
                            className="text-uppercase"
                            style={{ color: "#f57c00", fontSize: "0.65rem" }}
                          >
                            {month}
                          </div>
                          <div className="fw-bold">{day}</div>
                          <div
                            className="text-muted"
                            style={{ fontSize: "0.65rem", lineHeight: "1rem" }}
                          >
                            {dayName}, {year}
                          </div>
                        </div>
                      );
                    };

                    return (
                      <div
                        key={idx}
                        className="d-flex justify-content-between align-items-center rounded p-2 mb-2 shadow-sm bg-white border"
                      >
                        <span className="fw-semibold">{holiday.name}</span>
                        <span className="d-flex align-items-center">
                          {formatDateBox(start)}
                          {!isSameDay && (
                            <span className="fw-bold px-1">–</span>
                          )}
                          {!isSameDay && formatDateBox(end)}
                        </span>
                      </div>
                    );
                  })
                ) : (
                  <p className="text-muted">No holidays found.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {createNotice && (
        <Create_Notice
          setCreateNotice={setCreateNotice}
          createNotice={createNotice}
          onSucess1={onSucess}
          refetch={handleRefetch}
        />
      )}
      {listHolidays && (
        <NewHolidaysList
          holidays={allHolidays}
          setListHolidays={setListHolidays}
        />
        // <ListHolidays
        //   setListHolidays={setListHolidays}
        //   listHolidays={listHolidays}
        //   holidaysArray={holidaysArray}
        // />
        // <ListHolidays
        //   holidays={holidayData}
        // />
      )}
      {showModal && selectedNotice && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={() => setShowModal(false)}
        >
          <div style={{ position: "relative", paddingTop: "50px" }}>
            {/* Close Button Outside Modal */}
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: "25px",
                right: "65px",
                background: "#fff",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                border: "1px solid #ddd",
                borderRadius: "50%", // fully rounded
                width: "30px",
                height: "30px",
                fontSize: "16px",
                lineHeight: "1",
                textAlign: "center",
                padding: 0,
                cursor: "pointer",
                zIndex: 10,
                color: "#F77F00",
              }}
            >
              &times;
            </button>

            {/* Modal Box */}
            <div
              style={{
                backgroundColor: "#fff",
                width: "1300px",
                maxWidth: "85%",
                minHeight: "380px",
                maxHeight: "80vh",
                overflowY: "auto",
                borderRadius: "15px",
                padding: "20px",
                position: "relative",
                margin: "0 auto", // center it
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Body */}
              <div>
                <textarea
                  readOnly
                  className="form-control"
                  rows={8}
                  style={{
                    border: "2px solid orange",
                    resize: "none",
                    borderRadius: "10px",
                    padding: "10px",
                    fontSize: "16px",
                    width: "100%",
                  }}
                  value={selectedNotice.notice}
                ></textarea>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: "20px", // Adds gap between image section and link
                    flexWrap: "wrap", // Allows wrapping on smaller screens
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                >
                  {/* Image Attachments */}
                  {selectedNotice.attachments &&
                  selectedNotice.attachments.length > 0 ? (
                    <div style={{ flex: "1", minWidth: "200px" }}>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                          maxHeight: "160px",
                          overflowY: "auto",
                          padding: "5px",
                        }}
                      >
                        {selectedNotice.attachments.map((attachment, i) => {
                          const ext = getExtension(attachment);

                          return (
                            <div key={i} style={{ width: "120px" }}>
                              {isImage(ext) ? (
                                <img
                                  src={`${IP}${attachment}`}
                                  alt={`attachment-${i}`}
                                  onClick={() =>
                                    setZoomedImage(`${IP}${attachment}`)
                                  }
                                  style={{
                                    width: "120px",
                                    height: "80px",
                                    borderRadius: "5px",
                                    objectFit: "cover",
                                    border: "1px solid #ddd",
                                    cursor: "pointer",
                                  }}
                                />
                              ) : isPdf(ext) ? (
                                <div
                                  className="d-flex align-items-center gap-1"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleClickforpdf(attachment)}
                                >
                                  <img
                                    style={{ width: "70px" }}
                                    src={
                                      iconData?.find((i) => i.extension === ext)
                                        ?.icon
                                    }
                                    alt=""
                                  />
                                  <div>{attachformat(attachment)}</div>
                                </div>
                              ) : isVideo(ext) ? (
                                <div
                                  className="d-flex align-items-center gap-1"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    setZoomedImage(`${IP}${attachment}`)
                                  }
                                >
                                  <img
                                    style={{ width: "70px" }}
                                    src={
                                      iconData?.find(
                                        (i) => i.extension === "mp4",
                                      )?.icon
                                    }
                                    alt="video"
                                  />
                                  <div>{attachformat(attachment)}</div>
                                </div>
                              ) : (
                                <img
                                  style={{ width: "70px" }}
                                  src={
                                    iconData?.find((i) => i.extension === ext)
                                      ?.icon
                                  }
                                  alt="Icon"
                                />
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <p className="text-danger mt-2">No Attachment Found!!</p>
                  )}

                  {/* Embedded Link */}
                  {selectedNotice.embedded_link ? (
                    <div style={{ flexShrink: 0, maxWidth: "40%" }}>
                      <a
                        className="link"
                        href={
                          selectedNotice.embedded_link.includes("http")
                            ? selectedNotice.embedded_link
                            : `https://${selectedNotice.embedded_link}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p
                          className="notice_Link text-break mb-0"
                          style={{
                            wordBreak: "break-word",
                            fontWeight: "500",
                          }}
                        >
                          {selectedNotice.embedded_link}
                        </p>
                      </a>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {
        performanceReport && (
          <GeneratePerformance setPerformanceReport={setPerformanceReport} />
        )
      } */}
      {deleteNotice && (
        <DeleteNotice
          setDeleteNotice={setDeleteNotice}
          noticeId={deletedNoticeId}
          setDeletedNoticeId={setDeletedNoticeId}
          refatch={handleRefetch}
        />
      )}
      {teacherListPopup && (
        <ListOfTeachersPop
          setTeacherListPopup={setTeacherListPopup}
          teacherListPopup={teacherListPopup}
        />
      )}
      {mideaviewer && (
        <MideaViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}

      {zoomedImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          {/* Close button */}
          <button
            onClick={() => setZoomedImage(null)}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              background: "transparent",
              border: "none",
              fontSize: "2rem",
              color: "white",
              cursor: "pointer",
              zIndex: 10000,
            }}
            aria-label="Close"
          >
            &times;
          </button>

          {/* Zoomed Attachment */}
          {zoomedImage.split(".").pop() === "MP4" ||
          zoomedImage.split(".").pop() === "mp4" ? (
            <div
              className="midea_transprant_body"
              style={{ marginLeft: "0px" }}
            >
              <div className="SubfullSizeNoticeAttachment">
                <video className="videoPlayer" controls>
                  <source src={zoomedImage} type="video/mp4" />
                </video>
                <div></div>
              </div>
            </div>
          ) : (
            <img
              src={zoomedImage}
              alt="Zoomed"
              style={{
                maxWidth: "90%",
                maxHeight: "90%",
                borderRadius: "8px",
                boxShadow: "0 0 10px #000",
              }}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Add_class_material;
